import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination, Hospital } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  fornecedor: boolean,
}

interface Fornecedor {
  fornecedorId?: string,
  hisId?: string,
  nome: string,
  email: string,
  fabricante: string,
  status: 'Ativo' | 'Removido',
}

@Module({ namespaced: true, name: 'SuporteFornecedoresStore' })
export default class SuporteFornecedoresStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalId: string = ''
  public searchFornecedor: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    fornecedor: false,
  }

  @Mutation
  setSearchFornecedor(val: string) {
    this.searchFornecedor = val
  }

  @Mutation
  clearSearchFornecedor() {
    this.searchFornecedor = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** Fornecedores */
  private paginationFornecedorDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  public paginationFornecedor: DataTablePagination = { ...this.paginationFornecedorDefault }

  get paginatioDefault() {
    return this.paginationFornecedorDefault
  }

  private fornecedorDefault: Fornecedor = {
    fornecedorId: '',
    hisId: '',
    nome: '',
    email: '',
    fabricante: '',
    status: 'Ativo',
  }

  public fornecedor: Fornecedor = { ...this.fornecedorDefault }
  public fornecedoresDefault: Fornecedor[] = []
  public fornecedores: Fornecedor[] = [...this.fornecedoresDefault]

  @Mutation
  setFornecedores(value: Fornecedor[]) {
    this.fornecedores = value
  }

  @Mutation
  clearFornecedores() {
    this.fornecedores = [...this.fornecedoresDefault]
  }

  @Mutation
  setFornecedor(value: Fornecedor) {
    this.fornecedor = value
  }

  @Mutation
  clearFornecedor() {
    this.fornecedor = { ...this.fornecedorDefault }
  }

  @Mutation
  setPaginationFornecedor(val: DataTablePagination) {
    this.paginationFornecedor = val
  }

  @Action
  async getFornecedorPagedSearch(pagination: DataTablePagination) {
    const params: any = {
      hospitalId: this.hospitalId,
      pagina: pagination.page || this.paginationFornecedorDefault.page,
      qtdPorPagina: pagination.rowsPerPage || this.paginationFornecedorDefault.rowsPerPage,
      searchText: this.searchFornecedor,
    }

    const request = await Apis.Agendamento.SuporteApi.getAllFornecedores(params)

    if (request.success) {
      this.context.commit('setFornecedores', request.data.fornecedores as Fornecedor[] || [])
      this.context.commit('setPaginationFornecedor', {
        descending: false,
        page: pagination.page || this.paginationFornecedorDefault.page,
        rowsPerPage: pagination.rowsPerPage || this.paginationFornecedorDefault.rowsPerPage,
        sortBy: null,
        totalItems: request.data.total,
        rowsPerPageItems: this.paginationFornecedorDefault.rowsPerPageItems,
      })
    }

    return request
  }

  @Action
  async upsertFornecedor() {
    const params: Fornecedor = this.fornecedor
    Object.entries(params).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) delete params[key]
    })

    const request = await Apis.Agendamento.SuporteApi.upsertFornecedor({ hospitalId: this.hospitalId, ...params })
    return request
  }
}
